import React, { useEffect, useState } from "react";
import { API_BASE_URL } from "../config";

const Address = ({userId, companyId, onAddressesFetched, onAddressSelect }) => {
  const [addresses, setAddresses] = useState([]);
  const [selectedAddressId, setSelectedAddressId] = useState(null);
  const [formData, setFormData] = useState({
    id: 0,
    fullName: "",
    mobile: "",
    //email: "",
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    country: "",
    pincode: "",
    addressType: "Home",
    isDefault: false,
  });
  const [isEditing, setIsEditing] = useState(false);
  const [showForm, setShowForm] = useState(false);

  const fetchAddresses = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/Home/GetAddresses?companyId=${companyId}`);
      const text = await response.text();
      const data = text ? JSON.parse(text) : [];
      setAddresses(data);
      onAddressesFetched && onAddressesFetched(data);

      const defaultAddress = data.find((addr) => addr.isDefault);
      if (defaultAddress) {
        setSelectedAddressId(defaultAddress.id);
        handleSelectAddress(defaultAddress);
      }
    } catch (err) {
      console.error("Failed to fetch addresses:", err);
      setAddresses([]);
      onAddressesFetched && onAddressesFetched([]);
    }
  };

  useEffect(() => {
    if (companyId) fetchAddresses();
  }, [companyId]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const resetForm = () => {
    setFormData({
      id: 0,
      fullName: "",
      mobile: "",
      //email: "",
      addressLine1: "",
      addressLine2: "",
      city: "",
      state: "",
      country: "",
      pincode: "",
      addressType: "Home",
      isDefault: false,
    });
    setIsEditing(false);
    setShowForm(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const modelJson = JSON.stringify({ ...formData,userId, companyId });
    const formPayload = new FormData();
    formPayload.append("modelJson", modelJson);

    const url = isEditing
      ? `${API_BASE_URL}/Home/UpdateAddress`
      : `${API_BASE_URL}/Home/CreateAddress`;

    const response = await fetch(url, {
      method: "POST",
      body: formPayload,
    });

    if (response.ok) {
      resetForm();
      fetchAddresses();
    }
  };

  const handleEdit = (address) => {
    setFormData(address);
    setIsEditing(true);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this address?")) {
      await fetch(`${API_BASE_URL}/Home/DeleteAddress?id=${id}`, {
        method: "DELETE",
      });
      fetchAddresses();
    }
  };

  const handleSelectAddress = (address) => {
    setSelectedAddressId(address.id);
    onAddressSelect &&
      onAddressSelect({
        firstName: address.fullName,
        email: "",//address.email,
        phone: address.mobile,
        address: `${address.addressLine1} ${address.addressLine2}`,
        city: `${address.city}, ${address.state}`,
        country: address.country,
        zip: address.pincode,
      });
  };

  return (
    <div className="address-container" style={{ padding: "20px", maxWidth: "max-content", margin: "0 auto" }}>
      {addresses.length === 0 ? (
        <p>No addresses found.</p>
      ) : (
        <ul className="addressedit">
          {addresses.map((address) => (
            <li
              key={address.id}
              style={{
                marginBottom: "20px",
                width:'300px', height:'300px',
                border: "1px solid #ccc",
                padding: "15px",
                borderRadius: "8px",
                backgroundColor: selectedAddressId === address.id ? "#e9f7ff" : "#fff",
              }}
            >
              <label style={{ display: "flex", alignItems: "flex-start", gap: "10px", cursor: "pointer" }}>
                <input
                  type="radio"
                  name="selectedAddress"
                  value={address.id}
                  checked={selectedAddressId === address.id}
                  onChange={() => handleSelectAddress(address)}
                  style={{marginTop:'6px'}}
                />
                <div>
                  <strong>Name : {address.fullName}</strong><br />
                  {/* Email Id : {address.email}<br /> */}
                  Mobile : {address.mobile}<br />
                  Address : {address.addressLine1}, {address.addressLine2}<br />
                  {address.city}, {address.state}<br />
                  Pincode: {address.pincode}<br />
                  <small>{address.addressType}{address.isDefault ? " (Default)" : ""}</small>
                </div>
              </label>
              <div className="edit_Delete">
                <button onClick={() => handleEdit(address)} style={{ marginRight: "10px" }}>
                  Edit
                </button>
                <button onClick={() => handleDelete(address.id)}>Delete</button>
              </div>
            </li>
          ))}
        </ul>
      )}

      {showForm && (
        <>
          <h2 style={{ marginTop: "20px" }}>{isEditing ? "Edit Address" : "Add Address"}</h2>
          <form onSubmit={handleSubmit} className="address-form" style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            <input name="fullName" placeholder="Full Name" value={formData.fullName} onChange={handleChange} required />
            <input name="mobile" placeholder="Mobile" maxLength={12} value={formData.mobile} onChange={handleChange} required />
            {/* <input name="email" placeholder="Email" value={formData.email} onChange={handleChange} /> */}
            <input name="addressLine1" placeholder="Address Line 1" value={formData.addressLine1} onChange={handleChange} required />
            <input name="addressLine2" placeholder="Address Line 2" value={formData.addressLine2} onChange={handleChange} />
            <input name="city" placeholder="City" value={formData.city} onChange={handleChange} required />
            <input name="state" placeholder="State" value={formData.state} onChange={handleChange} required />
            <input name="country" placeholder="Country" value={formData.country} onChange={handleChange} required />
            <input name="pincode" placeholder="Pincode" value={formData.pincode} onChange={handleChange} required />
            <select className="addressType" name="addressType" value={formData.addressType} onChange={handleChange}>
              <option value="Home">Home</option>
              <option value="Office">Office</option>
            </select>
            <label style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <input type="checkbox" name="isDefault" checked={formData.isDefault} onChange={handleChange} />
              Set as default
            </label>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <button className="addAdress" type="submit">{isEditing ? "Update" : "Add"} Address</button>
              <button className="cancelAddress" type="button" onClick={resetForm}>
                Cancel
              </button>
            </div>
          </form>
        </>
      )}

      {!showForm && (
        <div
          onClick={() => {
            setIsEditing(false);
            setShowForm(true);
          }}
          style={{
            cursor: "pointer",
            marginTop: "20px",
            padding: "10px",
           boxShadow:'1px 1px 5px #ccc',
            textAlign: "center",
            borderRadius: "5px",
            color: "#000",
            width:'max-content', float:'right'
          }}
        >
          + Add Address
        </div>
      )}
    </div>
  );
};

export default Address;
